const TIME_ZONE_OFFSET = 2 * 60 * 60 * 1000

/**
 * Converts a date to a UTC timestamp adjusted for Kyiv timezone
 * @param {number} year - The year (e.g., 2023)
 * @param {number} month - The month (1-12)
 * @param {number} day - The day of the month
 * @param {number} [hour=0] - The hour (0-23)
 * @param {number} [sec=0] - The seconds (0-59)
 * @param {number} [milisec=0] - The milliseconds (0-999)
 * @returns {number} Timestamp in milliseconds adjusted for Kyiv timezone
 */
export function getTimestampByKyiv(year, month, day, hour = 0, sec = 0, milisec = 0) {
  return Date.UTC(year, month - 1, day, hour, sec, milisec) - TIME_ZONE_OFFSET
}
